<template>
  <c-modal-form
    :id="$getConst('FORM_QUALITY_SERVICE_MODAL_ID')"
    :logo-top="false"
    :loading="loading"
    :submit-btn-enabled="canSubmit"
    :error="error"
    title="Отзыв для сервиса «Служба качества»"
    @submit="submit()"
  >
    <div class="text-muted">
      <p>Уважаемый партнер!</p>
      <p v-if="selectedType === 'thanks'">
        Ваше мнение очень значимо для нас. Мы будем признательны, если Вы поделитесь с нами положительными результатами и достижениями, поблагодарите нас за проделанную работу или укажете те аспекты нашей деятельности, которые Вы высоко оценили.
      </p>
      <template v-else-if="selectedType === 'complain'">
        <p>Если у Вас есть вопросы или проблемы, которые мы не смогли решить в стандартном порядке; или Вы видите ошибки и недоработки в нашей деятельности — оставьте здесь Вашу заявку.</p>
        <p>Заявка будет рассмотрена Службой качества в максимально короткие сроки, ответственный сотрудник обязательно свяжется с Вами в течение 3-х рабочих часов.</p>
        <p>Мы заинтересованы в том, чтобы найти оптимальное для Вас решение и повысить качество нашей работы!</p>
      </template>
      <p v-else-if="selectedType === 'advice'">
        Если у Вас есть предложения, рекомендации или советы по нашей деятельности, которые направлены на улучшение нашей работы — напишите нам. Мы обязательно изучим Ваше предложение и постараемся оправдать Ваши ожидания.
      </p>
    </div>
    <form>
      <c-input
        v-model="name"
        placeholder="*Имя"
        form-group
      />
      <c-input
        v-model="email"
        placeholder="*E-mail"
        form-group
      />
      <c-textarea
        v-model="comment"
        placeholder="*Комментарий"
        :form-group="true"
        :row-count="5"
      />
    </form>
    <demo-denied />
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import CInput from '../../../../../../../resources/js/components/ui/CInput'
import CTextarea from '../../../../../../../resources/js/components/ui/CTextarea'
import form from '../../../../../../../resources/js/mixins/form'
import modal from '../../../../../../../resources/js/mixins/modal'
import apiService from '../../apiService'
import { mapGetters, mapState } from 'vuex'
import Notification from '../../../../../../../resources/js/notification'
import DemoDenied from '../DemoDenied'

/**
 * Модальное окно для отправки отзывы для сервиса «Служба качества».
 */
export default {
  name: 'QualityService',
  components: {
    DemoDenied,
    CModalForm,
    CInput,
    CTextarea
  },
  mixins: [form, modal],
  data () {
    return {
      name: '',
      email: '',
      comment: ''
    }
  },
  computed: {
    /**
     * Происходит ли загрузка или отправка данных.
     *
     * @returns {boolean}
     */
    loading () {
      return !!(this.sending || this.clientDomainsFetching || this.clientInfoFetching)
    },
    /**
     * Может ли форма быть отправлена.
     *
     * @returns {boolean}
     */
    canSubmit () {
      return !!(this.domainSelected && this.name && this.comment && this.email && !this.isDemo)
    },
    ...mapState({
      selectedType: state => state.seo.forms.qualityService.selectedType,
      domainSelected: state => state.seo.client.domains.selected,
      clientMail: state => state.seo.client.info.client.mail,
      clientDomainsFetching: state => state.seo.client.domains.fetching,
      clientInfoFetching: state => state.seo.client.info.fetching,
      formsQualityServiceSelectedType: state => state.seo.forms.qualityService.selectedType
    }),
    ...mapGetters({
      isDemo: 'seo/client/info/isDemo'
    })
  },
  mounted () {
    $(`#${this.$getConst('FORM_QUALITY_SERVICE_MODAL_ID')}`).on('hidden.bs.modal', () => {
      this.resetState()
    })

    this.$root.$on('clientInfoLoaded', () => {
      this.email = this.clientMail
    })
  },
  methods: {
    /**
     * Сбрасывает данные формы.
     */
    resetState () {
      this.name = ''
      this.email = this.clientMail || ''
      this.comment = ''
      this.error = false
    },
    /**
     * Отправляет данные формы.
     */
    submit () {
      this.sending = true
      this.error = false

      apiService.postFormsQualityService(
        this.domainSelected,
        this.name,
        this.comment,
        this.email,
        this.formsQualityServiceSelectedType
      )
        .then(() => {
          this.hideModal(this.$getConst('FORM_QUALITY_SERVICE_MODAL_ID'))
          this.resetState()

          this.sending = false

          Notification.notifySuccess({
            title: 'Данные отправлены'
          })
        })
        .catch(() => {
          this.sending = false

          this.error = true
        })
    }
  }
}
</script>
